import React from "react";
import IserbaGame1Wrapper from "./day1/Game1BeforeDriving";
import IserbaGame3Wrapper from "./day1/Game3WhileDriving";
import IserbaGame4Wrapper from "./day1/Game4WhileDriving";
import Game2RadioQuiz from "./day1/Game2RadioQuiz";
import IserbaPacMan from "./day2/IserbaPacMan";
import FallingObjectsGame from "./day3/FallingObjects";
import IserbaSafePlace from "./day4/SafePlace";
import { ImagePreloadProvider } from "context/ImagePreloadContext";

const IserbaQuestions = ({
	quiz,
	question,
	onAnswer,
	quizResults,
	setQuizResults,
	handleNext,
}) => {
	const { type } = question;

	return (
		<>
			<ImagePreloadProvider>
				{type === "click-puzzle" &&
					question.id === "0858e75a-78ad-40f9-924f-3acae97f19e2" && (
						<IserbaGame1Wrapper
							quiz={quiz}
							question={question}
							onAnswer={(value) => onAnswer(value)}
							quizResults={quizResults}
							setQuizResults={setQuizResults}
							handleNext={handleNext}
						/>
					)}

				{type === "click-puzzle" &&
					question.id === "cf84bee6-380c-4968-a549-e92aee153afc" && (
						<IserbaGame3Wrapper
							quiz={quiz}
							question={question}
							onAnswer={(value) => onAnswer(value)}
							quizResults={quizResults}
							setQuizResults={setQuizResults}
							handleNext={handleNext}
						/>
					)}

				{type === "click-puzzle" &&
					question.id === "2fe07195-ddbf-4f5a-9058-80ad9b288342" && (
						<IserbaGame4Wrapper
							quiz={quiz}
							question={question}
							onAnswer={(value) => onAnswer(value)}
							quizResults={quizResults}
							setQuizResults={setQuizResults}
							handleNext={handleNext}
						/>
					)}

				{type === "single-choice" && (
					<Game2RadioQuiz
						quiz={quiz}
						question={question}
						onAnswer={(value) => onAnswer(value)}
						quizResults={quizResults}
						setQuizResults={setQuizResults}
						handleNext={handleNext}
					/>
				)}

				{type === "pac-man" && (
					<IserbaPacMan
						quiz={quiz}
						question={question}
						onAnswer={(value) => onAnswer(value)}
						quizResults={quizResults}
						setQuizResults={setQuizResults}
						handleNext={handleNext}
					/>
				)}

				{type === "falling-objects" && (
					<FallingObjectsGame
						quiz={quiz}
						question={question}
						onAnswer={(value) => onAnswer(value)}
						quizResults={quizResults}
						setQuizResults={setQuizResults}
						handleNext={handleNext}
					/>
				)}

				{type === "safe-place" && (
					<IserbaSafePlace
						quiz={quiz}
						question={question}
						onAnswer={(value) => onAnswer(value)}
						quizResults={quizResults}
						setQuizResults={setQuizResults}
						handleNext={handleNext}
					/>
				)}
			</ImagePreloadProvider>
		</>
	);
};

export default IserbaQuestions;
